import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from "@angular/core";
import { NzTrMeasureComponent } from "ng-zorro-antd/table";

@Component({
  selector: "tr[ui-table-measure-row]",
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "tr-measure.component.html",
})
export class UiTrMeasureComponent extends NzTrMeasureComponent {
  @Input("listOfMeasureColumn") public listOfMeasureColumn: readonly string[] = [];
  @Output("listOfAutoWidth") public readonly listOfAutoWidth = new EventEmitter<number[]>();
  @ViewChildren("tdElement") public listOfTdElement!: QueryList<ElementRef>;
}
